import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import useFetchData from "../../../../../hooks/useFetchData";
import { DEFAULT_ADDITIONAL_LOCATION_DETAILS_STATE } from "../constants";
import { useStateIfMounted } from "use-state-if-mounted";

export const useAdditionalLocationDetails = (selectedWell) => {
  const { getAccessTokenSilently } = useAuth0();

  const [editorState, setEditorState] = useStateIfMounted(
    DEFAULT_ADDITIONAL_LOCATION_DETAILS_STATE
  );
  const [isDirty, setIsDirty] = useStateIfMounted(false);

  const handleUpdateState = (name, value) => {
    if (!isDirty) setIsDirty(true);
    setEditorState((prevState) => {
      let newFilterValues = { ...prevState };
      newFilterValues[name] = value;
      return newFilterValues;
    });
  };

  const handleResetState = () => {
    setIsDirty(false);
    if (selectedWell) {
      setEditorState(data);
    } else {
      setEditorState(DEFAULT_ADDITIONAL_LOCATION_DETAILS_STATE);
    }
  };

  const { data, isFetching, error, refetch } = useQuery(
    ["list-wells-location-details", selectedWell],
    async () => {
      if (!selectedWell) {
        setEditorState(DEFAULT_ADDITIONAL_LOCATION_DETAILS_STATE);
        return {};
      }
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };

        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/list-wells-location-details/${selectedWell}`,
          { headers }
        );
        setIsDirty(false);
        setEditorState(data);
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    }
  );

  const [groundwaterManagementDistrictLookup] = useFetchData(
    "ui-list-wm-gw-management-district",
    [],
    true
  );
  const [countyLookup] = useFetchData("ui-list-wm-county", [], true);

  return {
    data,
    isLoading: isFetching,
    error,
    refetch,
    isDirty,
    lookups: {
      groundwaterManagementDistrict: groundwaterManagementDistrictLookup,
      county: countyLookup,
    },
    handleUpdateState,
    handleResetState,
    state: editorState,
    setter: setEditorState,
  };
};
